import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, map, throwError } from 'rxjs';
import { ApiResponseModel } from 'src/app/models/shared-model';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../local-storage.service';
import { UserDetails } from 'src/app/models/authData';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  AUTH_BASE_URL = environment.AUTH_BASE_URL;
  ONBOARDING_BASE_URL = environment.ONBOARDING_BASE_URL;
  userData!: UserDetails;

  roleType: string = '';
  id: string = '';
  constructor(private http: HttpClient, private localStorageService: LocalStorageService) {
    this.localStorageService.getUserDetails().subscribe(userDetails => {
      this.userData = userDetails;
    });
  }
  public uploadFile(file: FormData): Observable<ApiResponseModel<string>> {
    return this.http.post<ApiResponseModel<string>>(this.AUTH_BASE_URL + '/upload', file);
  }

  public uploadFilesAndGetUrls(files: File[], destinationKey: string): Observable<string[]> {
    const formDataArray: FormData[] = [];
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('destinationKey', this.userData.userName + '/' + destinationKey + '/');
      formDataArray.push(formData);
    }

    const uploadRequests: Observable<ApiResponseModel<string>>[] = [];
    for (const formData of formDataArray) {
      uploadRequests.push(this.uploadFile(formData));
    }

    return forkJoin(uploadRequests).pipe(
      map(responses => responses.map(response => response.data))
    );
  }

  public exportFile(title: string, id: string): Observable<any> {
    if (title === 'Webinars') {
      const roleName = this.localStorageService.getItem('roleName');
      if (roleName === 'SUPER_ADMIN') {
        return this.http.get(this.ONBOARDING_BASE_URL + `/webinar/export/csv`, { responseType: 'blob' });
      } else {
              
        const params = new HttpParams().set('createdBy', id);
        return this.http.get(this.ONBOARDING_BASE_URL + `/webinar/export/csv`, { responseType: 'blob', params });
      }
    } else if (title === 'Jobs') {
      return this.http.get(this.ONBOARDING_BASE_URL + `/careers/export/${id}`, { responseType: 'blob' });
    } else if (title === 'Distributors') {
      return this.http.get(this.ONBOARDING_BASE_URL + '/distributor/export', { responseType: 'blob' });
    } else if (title === 'End Customers') {
      return this.http.get(this.ONBOARDING_BASE_URL + '/end-customer/export', { responseType: 'blob' });
    } else if (title === 'Exhibitions') {
      const roleName = this.localStorageService.getItem('roleName');
      if (roleName === 'SUPER_ADMIN') {
        return this.http.get(this.ONBOARDING_BASE_URL + `/exhibition/export-exhibitions/csv`, { responseType: 'blob' });
      } else {
                const params = new HttpParams().set('createdBy', id);
        return this.http.get(this.ONBOARDING_BASE_URL + `/exhibition/export-exhibitions/csv`, { responseType: 'blob', params });
      }

    } else if (title === 'OEMs') {
      return this.http.get(this.ONBOARDING_BASE_URL + '/oem/export-oem-csv', { responseType: 'blob' });
    }
    else if (title === 'Leads') {
      return this.http.get(this.ONBOARDING_BASE_URL + '/leads/export', { responseType: 'blob' });
    }
    else if (title === 'Products') {
      const roleName = this.localStorageService.getItem('roleName');
      switch (roleName) {
        case 'OEM': {
          this.id = this.localStorageService.getItem('oemId');
          return this.http.get(this.ONBOARDING_BASE_URL + `/productinfo/export?type=OEM&id=${this.id}`, { responseType: 'blob' });
        }
        case 'DISTRIBUTOR': {
          this.id = this.localStorageService.getItem('distributorId');
          return this.http.get(this.ONBOARDING_BASE_URL + `/productinfo/export?type=DISTRIBUTOR&id=${this.id}`, { responseType: 'blob' });
        }
        case 'SUPER_ADMIN': {
          return this.http.get(this.ONBOARDING_BASE_URL + `/productinfo/export?type=SUPER_ADMIN`, { responseType: 'blob' });
        }
      }
    }
    else if (title === 'WebinarRegisteredCustomers') {
      const params = new HttpParams().set('webinarPostId', id);
      return this.http.get(this.ONBOARDING_BASE_URL + `/webinar/export/registered-customers/csv`, {
        responseType: 'blob',
        params,
      });
      
    }
    return throwError(() => new Error('Invalid title specified'));
  }

}
